import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import Gantt from "../components/Gantt/Gantt";
import DashboardComponent from "../components/Gantt/Dashboard";
import KanBanComponent from "../components/Gantt/KanBan";
import FindingsComponent from "../components/Gantt/Findings";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import React, { useState } from "react";



function GanttPage(props) {
  const { token, activeDepartmentId, activeDepartment } = props;

  const collapsed = false;

  // simple string state (JS-safe). If you're using TS, you can type it later.
  const [viewOption, setViewOption] = useState("Action"); // "Project" | "Action"

  const handleViewProject = () => setViewOption("Gantt");
  const handleViewAction = () => setViewOption("Action");
  const handleViewKanBan = () => setViewOption("KanBan");
  const handleViewFindings = () => setViewOption("Findings");

  return token ? (
    <div className="flex flex-col w-full h-screen overflow-x-hidden">
      {/* TopBar */}
      {!activeDepartmentId && (
        <TopBar className="fixed top-0 left-0 right-0 z-10" />
      )}

      <div className="flex flex-row w-full h-full">
        {/* Sidebar */}
        {!activeDepartmentId && (
          <Sidebar
            collapsed={collapsed}
            className="fixed top-0 left-0 h-screen pt-[64px] z-0"
          />
        )}

        {/* Main content */}
        <div
          id="dashboard-content"
          className={`flex flex-col h-full overflow-y-auto p-4 transition-all duration-300`}
        >
          {/* Tabs */}
          <div
            className={`flex justify-start items-center mb-4 space-x-8 pl-2 sm:pl-4 transition-all duration-200 ${viewOption !== "Gantt" ? "ml-6 sm:ml-10" : "ml-0"
              }` }
          >
            
             <button
              onClick={handleViewFindings}
              className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "Findings"
                  ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                  : "text-gray-500 hover:text-[#3b3b3b]"
                }`}
            >
              Findings
            </button>
            
            <button
              onClick={handleViewAction}
              className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "Action"
                  ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                  : "text-gray-500 hover:text-[#3b3b3b]"
                }`}
            >
              Action
            </button>

            <button
              onClick={handleViewProject}
              className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "Gantt"
                  ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                  : "text-gray-500 hover:text-[#3b3b3b]"
                }`}
            >
              Gantt
            </button>

            <button
              onClick={handleViewKanBan}
              className={`pb-2 text-sm font-medium transition-colors duration-200 ${viewOption === "KanBan"
                  ? "text-[#3b3b3b] border-b-2 border-[#3b3b3b]"
                  : "text-gray-500 hover:text-[#3b3b3b]"
                }`}
            >
              KanBan
            </button>

          </div>
          {/* Content switch */}
          {viewOption === "Gantt" ? (
            // Gantt container
            <div className="overflow-x-auto w-full h-full">
              <Gantt
                activeDepartmentId={activeDepartmentId}
                activeDepartment={activeDepartment}
              />
            </div>
          ) : viewOption === "KanBan" ? (
            // Kanban container
            <div className="overflow-x-auto w-full h-full">
              <KanBanComponent
                activeDepartmentId={activeDepartmentId}
                activeDepartment={activeDepartment}
              />
            </div>
          ) : viewOption === "Findings" ? (
            // Findings container
            <div className="overflow-x-auto w-full h-full">
              <FindingsComponent
                activeDepartmentId={activeDepartmentId}
                activeDepartment={activeDepartment}
              />
            </div>
          ) : (
            // Dashboard container (default)
            <div className="overflow-x-auto w-full h-full">
              <DashboardComponent
                activeDepartmentId={activeDepartmentId}
                activeDepartment={activeDepartment}
              />
            </div>
)}
        </div>
      </div>
    </div>
  ) : (
    <Redirect to="/login" />
  );
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default compose(connect(mapStateToProps))(GanttPage);
